import { ISimilarity } from 'APIPackage/SimilarityModule/interfaces/ISimilarity';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { SimilaritiesLinkCell } from '../components/SimilaritiesLinkCell';

export const similaritiesTableHeaders: ITableColumn<ISimilarity>[] = [
  {
    name: 'НАИМЕНОВАНИЕ ПРОВЕРЯЕМОГО ЛИЦА',
    id: 'organizationName',
    isDisabledSort: true,
    renderCell: SimilaritiesLinkCell,
  },
  {
    name: 'ИНН',
    id: 'inn',
    sort: TableColumnSortEnum.NONE,
  },
  {
    name: 'ОГРН',
    id: 'ogrn',
    sort: TableColumnSortEnum.NONE,
  },
  {
    name: 'СТАТУС ЮЛ',
    id: 'status',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'КОЛИЧЕСТВО СОВПАДЕНИЙ',
    id: 'count',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'ОБЩАЯ ДЛИТЕЛЬНОСТЬ (В ДНЯХ)',
    id: 'durationDays',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'ОБЩАЯ ДЛИТЕЛЬНОСТЬ (В ЧАСАХ)',
    id: 'durationHours',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'КОЛИЧЕСТВО СОВПАДЕНИЙ ПО РФ',
    id: 'totalCount',
    tooltip: 'Количество всех проверок по данному Юридическому Лицу по всей РФ',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'ОБЩАЯ ДЛИТЕЛЬНОСТЬ (В ДНЯХ) ПО РФ',
    id: 'totalDurationDays',
    tooltip: 'Общая длительность (в днях) всех проверок по данному Юридическому Лицу по всей РФ',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
  {
    name: 'ОБЩАЯ ДЛИТЕЛЬНОСТЬ (В ЧАСАХ) ПО РФ',
    id: 'totalDurationHours',
    tooltip: 'Общая длительность (в часах) всех проверок по данному Юридическому Лицу по всей РФ',
    isDisabledSort: true,
    dataColumnType: 'centre',
  },
];
